import { useState, useEffect, useRef } from 'react';
// import { useAppKitAccount } from '@reown/appkit/react';

function App() {
  const [isConnected, setIsConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  
  const [showLanding, setShowLanding] = useState(true);
  const [bootStatus, setBootStatus] = useState('INITIALIZING_CORE...');
  const [bootProgress, setBootProgress] = useState(0);
  const [sessionCount, setSessionCount] = useState(() => {
    return parseInt(localStorage.getItem('ghost_sessions') || '1542');
  });

  const [scale, setScale] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      // Fit to the smallest dimension so it never gets cut off horizontally on mobile
      const scaleX = window.innerWidth / 1100;
      const scaleY = window.innerHeight / 1100;
      setScale(Math.min(scaleX * 0.95, scaleY * 0.95));
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [stakeAmount, setStakeAmount] = useState('');
  const [yields, setYields] = useState({
    btcb: 0.0000,
    eth: 0.0000,
    usdt: 0.0000,
    paxg: 0.0000
  });

  const [vibeMuted, setVibeMuted] = useState(true);
  const videoRef = useRef(null);

  const [showFarmerModal, setShowFarmerModal] = useState(false);
  const mockFarmers = [
    { id: '8834', name: 'Alpha Farmer #8834', power: 'High Yield' },
    { id: '9012', name: 'Beta Farmer #9012', power: 'Standard Yield' },
    { id: '1105', name: 'Gamma Farmer #1105', power: 'Standard Yield' },
    { id: '3391', name: 'Delta Farmer #3391', power: 'Low Yield' }
  ];

  const handleEntry = () => {
    const newCount = sessionCount + 1;
    setSessionCount(newCount);
    localStorage.setItem('ghost_sessions', newCount.toString());
    setShowLanding(false);
  };

  const handleSyncSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      setVibeMuted(false);
    }
  };

  useEffect(() => {
    if (showLanding) {
      const messages = [
        'CONNECTING_RWA_NODES...',
        'DECRYPTING_VAULT_PROTOCOLS...',
        'SYNCING_LIQUIDITY_POOLS...',
        'BYPASSING_CENTRAL_AUTH...',
        'SYSTEM_READY'
      ];
      let i = 0;
      const interval = setInterval(() => {
        setBootStatus(messages[i]);
        setBootProgress(((i + 1) / messages.length) * 100);
        i++;
        if (i === messages.length) clearInterval(interval);
      }, 700);
      return () => clearInterval(interval);
    }
  }, [showLanding]);

  useEffect(() => {
    if (!isConnected || showLanding) return;
    const interval = setInterval(() => {
      setYields(prev => ({
        btcb: prev.btcb + (Math.random() * 0.000001),
        eth: prev.eth + (Math.random() * 0.00001),
        usdt: prev.usdt + (Math.random() * 0.01),
        paxg: prev.paxg + (Math.random() * 0.000005)
      }));
    }, 1500);
    return () => clearInterval(interval);
  }, [isConnected, showLanding]);

  if (showLanding) {
    console.log('🔵 LANDING PAGE RENDERING');
    return (
      <div className="relative w-screen h-[100dvh] xl:h-screen bg-black overflow-hidden flex items-center justify-center font-sans text-white">
        {/* <div className="absolute inset-0 scanline z-20 pointer-events-none"></div> */}
        {/* <div className="absolute inset-0 cyber-grid z-10 opacity-20 pointer-events-none"></div> */}
        {/* <div className="absolute inset-0 crt-overlay z-[25] pointer-events-none"></div> */}

        <video 
          ref={videoRef}
          autoPlay 
          loop 
          muted={vibeMuted}
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-contain md:object-cover opacity-70 z-0 bg-black"
          poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
          onError={(e) => console.error('VIDEO FAILED:', e)}
        >
          <source src="./intro_vortex.mp4" type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black z-10"></div>
        
        {/* DESKTOP EXACT REVERT */}
        <div className="hidden xl:flex absolute inset-0 z-30 flex-col items-center justify-between py-[12vh] w-full px-4 md:px-8">
          <div className="text-center w-full max-w-[100vw] overflow-hidden">
            <h1 className="text-[10vw] md:text-[8vw] lg:text-[clamp(3rem,5vw,8rem)] font-black text-white opacity-90 drop-shadow-[0_0_40px_rgba(0,255,136,0.7)] uppercase italic animate-pulse tracking-[0.2em] md:tracking-[0.6em] whitespace-nowrap">
              KEDZÆCARTA
            </h1>
            <div className="h-[2px] w-full max-w-4xl mx-auto bg-gradient-to-r from-transparent via-cyan-500 to-transparent mt-8"></div>
          </div>

          <div className="flex flex-col items-center w-full mt-auto mb-[10vh]">
            <div className="w-full max-w-[500px] h-1.5 bg-white/5 rounded-full overflow-hidden mb-16">
              <div 
                className="h-full bg-cyan-400 shadow-[0_0_20px_rgba(34,211,238,1)] transition-all duration-300"
                style={{ width: `${bootProgress}%` }}
              ></div>
            </div>

            {bootProgress < 100 ? (
              <div className="text-cyan-400 font-mono text-xs animate-pulse uppercase" style={{ letterSpacing: '0.6em' }}>
                {bootStatus}
              </div>
            ) : (
              <div className="flex flex-col items-center gap-12">
                <button 
                  onClick={handleEntry}
                  className="group relative px-6 py-4 md:px-24 md:py-8 bg-white/5 border-2 border-cyan-400/40 rounded-xl overflow-hidden transition-all duration-500 hover:border-cyan-400 hover:bg-cyan-400/20 hover:scale-110 active:scale-95 shadow-[0_0_60px_rgba(34,211,238,0.25)] w-full max-w-[90%] md:max-w-none"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-magenta-500/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <span className="relative text-white font-black text-lg md:text-2xl uppercase tracking-[0.2em] md:tracking-[0.8em]">
                    INITIATE_SESSION
                  </span>
                  <div className="absolute -inset-1 bg-cyan-400 opacity-0 group-hover:opacity-40 blur-3xl transition-opacity"></div>
                </button>
              </div>
            )}
          </div>

          <div className="mt-auto flex flex-col items-center gap-6">
             {vibeMuted && (
               <button 
                 onClick={handleSyncSound}
                 className="px-6 py-2 border border-white/20 rounded-full text-[10px] font-bold tracking-widest uppercase hover:bg-white/10 transition-colors flex items-center gap-2"
               >
                 <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
                 ACTIVATE_AUDIO_SYNC
               </button>
             )}
             
             <div className="flex flex-col md:flex-row gap-8 items-center opacity-40">
                <div className="flex items-center gap-3">
                  <div className={`w-1.5 h-1.5 rounded-full ${vibeMuted ? 'bg-yellow-400 animate-pulse' : 'bg-emerald-400'}`}></div>
                  <span className="text-[10px] font-bold text-white tracking-widest uppercase">
                    {vibeMuted ? 'AUDIO: PENDING' : 'AUDIO: LIVE'}
                  </span>
                </div>
                <div className="w-[1px] h-3 bg-white/20"></div>
                <div className="flex items-center gap-3">
                  <div className="w-1 h-1 bg-cyan-400 rounded-full"></div>
                  <span className="text-[10px] font-bold text-white tracking-widest uppercase">ENCRYPTION: ACTIVE</span>
                </div>
             </div>
          </div>
        </div>

        {/* MOBILE ONLY SEPARATE LAYOUT */}
        <div className="relative z-30 flex xl:hidden flex-col items-center justify-between h-[100dvh] w-full px-4 py-16">
          <div className="text-center w-full">
            <h1 className="text-4xl font-black text-white opacity-90 drop-shadow-[0_0_40px_rgba(0,255,136,0.7)] uppercase italic animate-pulse tracking-[0.2em] whitespace-nowrap">
              KEDZÆCARTA
            </h1>
            <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-cyan-500 to-transparent mt-4"></div>
          </div>

          <div className="flex flex-col items-center w-full gap-4">
            <div className="w-full h-1.5 bg-white/5 rounded-full overflow-hidden mb-8">
              <div 
                className="h-full bg-cyan-400 shadow-[0_0_20px_rgba(34,211,238,1)] transition-all duration-300"
                style={{ width: `${bootProgress}%` }}
              ></div>
            </div>

            {bootProgress < 100 ? (
              <div className="text-cyan-400 font-mono text-[10px] animate-pulse uppercase text-center" style={{ letterSpacing: '0.6em' }}>
                {bootStatus}
              </div>
            ) : (
              <div className="flex flex-col items-center w-full">
                <button 
                  onClick={handleEntry}
                  className="group relative px-6 py-4 bg-white/5 border-2 border-cyan-400/40 rounded-xl overflow-hidden transition-all duration-500 hover:border-cyan-400 hover:bg-cyan-400/20 active:scale-95 shadow-[0_0_60px_rgba(34,211,238,0.25)] w-full"
                >
                  <span className="relative text-white font-black text-lg uppercase tracking-[0.2em]">
                    INITIATE_SESSION
                  </span>
                </button>
              </div>
            )}

            <div className="mt-8 flex flex-col items-center gap-4 w-full">
               <div className="flex flex-col gap-2 items-center opacity-40">
                  <div className="flex items-center gap-2">
                    <div className={`w-1.5 h-1.5 rounded-full ${vibeMuted ? 'bg-yellow-400 animate-pulse' : 'bg-emerald-400'}`}></div>
                    <span className="text-[8px] font-bold text-white tracking-widest uppercase">
                      {vibeMuted ? 'AUDIO: PENDING' : 'AUDIO: LIVE'}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1 h-1 bg-cyan-400 rounded-full"></div>
                    <span className="text-[8px] font-bold text-white tracking-widest uppercase">ENCRYPTION: ACTIVE</span>
                  </div>
               </div>
            </div>
          </div>
        </div>

        <div className="absolute top-10 left-10 w-32 h-10 border-t border-l border-white/20 flex items-center pl-4">
            <div className="text-[8px] text-white/30 font-mono tracking-widest uppercase">Terminal_01</div>
        </div>
        <div className="absolute top-10 right-10 flex items-center gap-2 px-4 py-2 border border-cyan-500/20 bg-cyan-500/5 rounded-full">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-ping"></div>
            <div className="text-[8px] text-cyan-400 font-bold tracking-[0.3em] uppercase">SECTOR_07: ACTIVE</div>
        </div>
        <div className="absolute bottom-10 right-10 w-32 h-10 border-b border-r border-white/20 flex items-center justify-end pr-4">
            <div className="text-[8px] text-white/30 font-mono tracking-widest uppercase">ID: KEDZACARTA</div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-[100dvh] xl:min-h-screen bg-[#000000] flex flex-col xl:flex-row items-center justify-start xl:justify-center overflow-x-hidden overflow-y-auto xl:overflow-hidden font-sans animate-in fade-in zoom-in duration-1000 relative">
      <div className="fixed inset-0 pointer-events-none z-0 opacity-40 bg-[radial-gradient(circle_at_50%_50%,rgba(0,255,136,0.15),transparent_80%)]"></div>
      {/* <div className="fixed inset-0 cyber-grid opacity-10 pointer-events-none"></div> */}
      {/* <div className="fixed inset-0 scanline opacity-5 pointer-events-none"></div> */}      
      
      <div className="hidden xl:flex fixed left-0 top-0 bottom-0 w-[25vw] flex-col gap-8 p-12 z-50 border-r border-cyan-500/20 bg-gradient-to-r from-cyan-950/20 to-transparent overflow-y-auto">
        <div className="relative group w-full mb-4">
          <div className="absolute -inset-2 bg-cyan-500/30 rounded-xl blur-xl opacity-50 group-hover:opacity-100 transition duration-1000"></div>
          <div className="relative bg-black rounded-xl border-2 border-cyan-400 overflow-hidden shadow-[0_0_60px_rgba(34,211,238,0.3)] flex flex-col">
            <video autoPlay loop muted playsInline className="w-full aspect-[9/16] object-cover scale-110">
              <source src="/shiba_digging.mp4" type="video/mp4" />
            </video>
            <div className="relative z-10 bg-[#0F0B1A] border-t border-cyan-500/30 p-6 flex flex-col gap-2 w-full">
              <div className="flex items-center gap-4">
                <div className="relative w-4 h-4 flex items-center justify-center">
                   <div className="absolute inset-0 bg-cyan-400 rounded-full animate-ping opacity-75"></div>
                   <div className="relative w-2 h-2 bg-cyan-400 rounded-full shadow-[0_0_10px_rgba(34,211,238,1)]"></div>
                </div>
                <span className="text-xl font-black text-cyan-400 tracking-[0.5em] uppercase drop-shadow-[0_0_10px_rgba(34,211,238,1)]">DEEP_MINING</span>
              </div>
              <span className="text-xs font-mono text-cyan-400/60 uppercase tracking-[0.2em]">SECTOR: RWA_VAULT_01</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-6 w-full bg-cyan-900/10 p-6 border-l-4 border-cyan-500 rounded-r-xl">
          <div className="text-xl font-black text-cyan-400 tracking-[0.3em] uppercase mb-2">REVENUE_SPLIT</div>
          <div className="grid grid-cols-1 gap-4 font-mono">
             <div className="flex justify-between items-center border-b border-cyan-500/10 pb-2">
                <span className="text-[10px] font-bold text-white/40 tracking-widest uppercase">DEV (THE DOLLAR)</span>
                <span className="text-xl font-black text-white italic">30%</span>
             </div>
             <div className="flex justify-between items-center border-b border-cyan-500/10 pb-2">
                <span className="text-[10px] font-bold text-white/40 tracking-widest uppercase">TREASURY (VAULT)</span>
                <span className="text-xl font-black text-cyan-400 italic">50%</span>
             </div>
             <div className="flex justify-between items-center">
                <span className="text-[10px] font-bold text-white/40 tracking-widest uppercase">FARM OWNER</span>
                <span className="text-xl font-black text-white italic">20%</span>
             </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 w-full opacity-60">
          <div className="text-lg font-black text-white/40 tracking-[0.3em] uppercase mb-2 italic">YIELD_MATRIX</div>
          <div className="space-y-1 font-mono text-[10px]">
            <div className="flex justify-between border-b border-white/5 pb-1">
              <span className="uppercase">Base APR:</span>
              <span className="text-cyan-400">8.0%</span>
            </div>
            <div className="flex justify-between border-b border-white/5 pb-1">
              <span className="uppercase">30 Days:</span>
              <span className="text-white">12.5%</span>
            </div>
            <div className="flex justify-between border-b border-white/5 pb-1">
              <span className="uppercase">120+ Days:</span>
              <span className="text-emerald-400 font-black">25.0%</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden xl:flex fixed right-0 top-0 bottom-0 w-[25vw] flex-col gap-8 p-12 z-50 border-l border-magenta-500/20 bg-gradient-to-l from-magenta-950/20 to-transparent text-right overflow-y-auto">
        <div className="flex flex-col gap-6 w-full p-6 bg-magenta-900/10 border-r-4 border-magenta-500 rounded-l-xl italic text-right">
          <div className="text-xl font-black text-magenta-400 tracking-[0.3em] uppercase mb-2">PAYOUT_LOGIC</div>
          <div className="flex flex-col gap-4">
             <div className="flex flex-col gap-1">
                <span className="text-[10px] text-white/40 uppercase font-bold tracking-widest">ASSET_ALLOCATION</span>
                <span className="text-2xl font-black text-white italic uppercase">BTCB | ETH | USDT | PAXG</span>
             </div>
             <div className="flex flex-col gap-1">
                <span className="text-[10px] text-magenta-400/60 uppercase font-bold tracking-widest">INJECTION_FREQUENCY</span>
                <span className="text-2xl text-magenta-400 font-black uppercase tracking-[0.3em]">5X DAILY SYNC</span>
             </div>
          </div>
        </div>

        <div className="flex flex-col gap-6 w-full py-6 border-b-2 border-magenta-500/30 italic">
          <div className="text-2xl font-black text-white tracking-[0.4em] uppercase">VAULT_DYNAMICS</div>
          <div className="flex flex-col gap-2">
            <span className="text-xs text-white/40 uppercase font-bold tracking-widest">AGGREGATED_YIELD_TVL</span>
            <span className="text-5xl font-black text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.3)]">$2,842,109</span>
          </div>
        </div>

        <div className="flex flex-col gap-4 w-full">
          <div className="text-lg font-black text-purple-400 tracking-[0.4em] uppercase mb-2 border-b border-purple-500/20 pb-4 italic">LIVE_TRANSACTIONS</div>
          <div className="flex flex-col gap-3">
            {['0x42a...f91c', '0xb12...33d2', '0x992...e110'].map((tx, i) => (
              <div key={i} className="flex justify-between items-center bg-magenta-500/5 p-3 rounded border-r-2 border-magenta-500/40">
                <span className="text-magenta-400 font-mono text-sm">{tx}</span>
                <span className="text-[8px] text-white/20 font-bold uppercase">CONFIRMED</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-auto flex flex-col gap-4 opacity-30 group cursor-default">
           <div className="h-[2px] w-full bg-gradient-to-l from-magenta-500 to-transparent"></div>
           <div className="text-[10px] font-black text-white tracking-[0.5em] uppercase">SYSTEM_STABLE_v10.0.12</div>
           <div className="text-[8px] font-mono text-white/40 tracking-widest uppercase italic font-bold">ID: DEGEN_PROTOCOL_CORE</div>
        </div>
      </div>

      {/* NATIVE MOBILE OPTIMIZED DASHBOARD */}
      <div className="flex xl:hidden flex-col w-full max-w-md mx-auto px-4 gap-4 order-1 mt-6 z-10 relative pb-12">
        <div className="flex items-center justify-between">
            <h1 className="text-xl md:text-2xl font-black tracking-[0.2em] text-white opacity-90 drop-shadow-[0_0_15px_rgba(0,255,136,0.5)] uppercase">KEDZÆCARTA</h1>
            <button 
              onClick={async () => {
                if (typeof window !== 'undefined' && (window as any).ethereum) {
                  try {
                    const accounts = await (window as any).ethereum.request({ method: 'eth_requestAccounts' });
                    if (accounts && accounts.length > 0) {
                      setIsConnected(true);
                      setWalletAddress(accounts[0]);
                    }
                  } catch (e) {
                    console.error("User rejected request");
                  }
                } else {
                  alert('Web3 Wallet not found! Please install MetaMask.');
                }
              }}
              className={`px-4 py-2 border-2 transition-all text-[10px] font-black uppercase tracking-widest rounded-full shadow-[0_0_20px_rgba(34,211,238,0.3)] cursor-pointer ${isConnected ? 'bg-cyan-500/20 border-cyan-500/40 text-cyan-400' : 'bg-magenta-500/20 border-magenta-400 text-magenta-400 hover:bg-magenta-400 hover:text-black'}`}
            >
              {isConnected ? `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}` : 'CONNECT WALLET'}
            </button>
        </div>
        
        <div className="flex flex-col gap-2 bg-emerald-500/10 p-6 rounded-2xl border border-emerald-500/30 text-center shadow-[0_0_30px_rgba(16,185,129,0.15)]">
            <h2 className="text-[10px] font-black tracking-[0.4em] text-emerald-400 uppercase">VAULT_LIQUIDITY_LIVE</h2>
            <div className="text-3xl md:text-4xl font-black tracking-tight text-white flex items-baseline justify-center gap-2">
                <span className="text-emerald-400 text-xl">$</span>2,842,109.42
            </div>
            <div className="flex justify-center gap-4 mt-2 border-t border-emerald-500/20 pt-4">
                <span className="text-[9px] font-black text-white uppercase tracking-widest"><span className="text-orange-400">BTC</span> 4.2</span>
                <span className="text-[9px] font-black text-white uppercase tracking-widest"><span className="text-blue-400">ETH</span> 82.5</span>
                <span className="text-[9px] font-black text-white uppercase tracking-widest"><span className="text-yellow-400">PAXG</span> 120.0</span>
            </div>
        </div>

        {/* STAKE FARMER MOBILE */}
        <div className="flex flex-col bg-[#0F0B1A]/80 backdrop-blur-md border border-cyan-500/40 rounded-3xl p-5 shadow-[0_0_30px_rgba(34,211,238,0.2)]">
            <h2 className="text-2xl font-black text-cyan-400 tracking-[0.3em] mb-2 uppercase text-center">STAKE FARMER NFT</h2>
            <p className="text-[10px] font-bold text-cyan-400/60 tracking-[0.1em] uppercase text-center mb-6">Lock your Farmer NFT to harvest KCFT yields.</p>
            <div className="relative w-full h-14 flex items-center bg-cyan-900/20 border-b-2 border-cyan-500/50 overflow-hidden mb-4">
                <input type="number" placeholder="ID #" value={stakeAmount} onChange={(e) => setStakeAmount(e.target.value)} className="w-full h-full bg-transparent p-4 pr-16 text-white text-2xl outline-none font-black text-right" />
                <button onClick={() => setShowFarmerModal(true)} className="absolute right-4 text-cyan-400 font-black text-[10px] hover:text-white uppercase tracking-[0.2em] bg-cyan-500/20 px-3 py-2 rounded border border-cyan-500/40 shadow-[0_0_10px_rgba(34,211,238,0.2)] transition-all">SELECT</button>
            </div>
            <button className="w-full h-14 bg-cyan-500/10 hover:bg-cyan-400 border border-cyan-400 rounded-xl text-cyan-400 hover:text-black font-black tracking-[0.3em] uppercase transition-all shadow-[0_0_20px_rgba(34,211,238,0.2)]" onClick={() => isConnected && alert(`STAKING FARMER ID: ${stakeAmount || '0'}`)}>INITIATE LOCK</button>
        </div>

        {/* YIELD HARVEST MOBILE */}
        <div className="flex flex-col bg-[#1A0B1A]/80 backdrop-blur-md border border-magenta-500/40 rounded-3xl p-5 shadow-[0_0_30px_rgba(255,0,255,0.2)]">
            <h2 className="text-2xl font-black text-magenta-400 tracking-[0.3em] mb-2 uppercase text-center">YIELD HARVEST</h2>
            <p className="text-[10px] font-bold text-magenta-400/60 tracking-[0.1em] uppercase text-center mb-6">Real-time yields aggregated from RWA vault assets.</p>
            <div className="flex flex-col gap-2 mb-4">
                <div className="flex items-center justify-between bg-magenta-900/20 p-3 rounded-xl border border-magenta-500/30">
                    <span className="font-black text-magenta-400 tracking-widest opacity-80 text-xs">[ BTCB ]</span>
                    <span className="font-black text-xl text-magenta-400">{yields.btcb.toFixed(6)}</span>
                </div>
                <div className="flex items-center justify-between bg-magenta-900/20 p-3 rounded-xl border border-magenta-500/30">
                    <span className="font-black text-magenta-400 tracking-widest opacity-80 text-xs">[ ETH ]</span>
                    <span className="font-black text-xl text-magenta-400">{yields.eth.toFixed(6)}</span>
                </div>
                <div className="flex items-center justify-between bg-magenta-900/20 p-3 rounded-xl border border-magenta-500/30">
                    <span className="font-black text-magenta-400 tracking-widest opacity-80 text-xs">[ PAXG ]</span>
                    <span className="font-black text-xl text-magenta-400">{yields.paxg.toFixed(6)}</span>
                </div>
            </div>
            <button className={`w-full h-14 rounded-xl border font-black tracking-[0.3em] uppercase transition-all ${isConnected ? 'bg-emerald-500/10 border-emerald-400 text-emerald-400 shadow-[0_0_20px_rgba(16,185,129,0.3)]' : 'bg-gray-900/40 border-gray-800 text-gray-700 opacity-50'}`} onClick={() => isConnected && alert('HARVESTING ALL RWA YIELDS...')}>
                {isConnected ? 'HARVEST ALL' : 'OFFLINE'}
            </button>
        </div>

        {/* MOBILE STACKED DATA BLOCKS */}
        <div className="flex flex-col gap-4 mt-2">
            <div className="flex flex-col gap-4 w-full bg-cyan-900/10 p-5 border-l-2 border-cyan-500 rounded-r-xl">
                <div className="text-sm font-black text-cyan-400 tracking-[0.2em] uppercase">REVENUE_SPLIT</div>
                <div className="flex flex-col gap-3 font-mono">
                    <div className="flex justify-between items-center border-b border-cyan-500/10 pb-2">
                        <span className="text-[9px] font-bold text-white/40 tracking-widest uppercase">DEV (THE DOLLAR)</span>
                        <span className="text-lg font-black text-white italic">30%</span>
                    </div>
                    <div className="flex justify-between items-center border-b border-cyan-500/10 pb-2">
                        <span className="text-[9px] font-bold text-white/40 tracking-widest uppercase">TREASURY (VAULT)</span>
                        <span className="text-lg font-black text-cyan-400 italic">50%</span>
                    </div>
                    <div className="flex justify-between items-center">
                        <span className="text-[9px] font-bold text-white/40 tracking-widest uppercase">FARM OWNER</span>
                        <span className="text-lg font-black text-white italic">20%</span>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-3 w-full bg-magenta-900/10 p-5 border-r-2 border-magenta-500 rounded-l-xl">
                <div className="text-sm font-black text-magenta-400 tracking-[0.2em] uppercase text-right">YIELD_MATRIX</div>
                <div className="flex flex-col gap-2 font-mono text-[10px]">
                    <div className="flex justify-between border-b border-magenta-500/10 pb-1">
                        <span className="uppercase text-white/40">Base APR:</span>
                        <span className="text-cyan-400 font-bold">8.0%</span>
                    </div>
                    <div className="flex justify-between border-b border-magenta-500/10 pb-1">
                        <span className="uppercase text-white/40">30 Days:</span>
                        <span className="text-white font-bold">12.5%</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="uppercase text-white/40">120+ Days:</span>
                        <span className="text-emerald-400 font-black">25.0%</span>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-3 w-full mt-4">
                <div className="text-xs font-black text-purple-400 tracking-[0.3em] uppercase border-b border-purple-500/20 pb-2 italic">LIVE_TRANSACTIONS</div>
                <div className="flex flex-col gap-2">
                    {['0x42a...f91c', '0xb12...33d2', '0x992...e110'].map((tx, i) => (
                    <div key={i} className="flex justify-between items-center bg-magenta-500/5 p-2.5 rounded border-l border-magenta-500/30">
                        <span className="text-magenta-400 font-mono text-xs">{tx}</span>
                        <span className="text-[8px] text-emerald-400/80 font-bold uppercase tracking-widest">CONFIRMED</span>
                    </div>
                    ))}
                </div>
            </div>

            <div className="flex flex-col items-center gap-2 opacity-30 mt-8 mb-4">
                <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-magenta-500 to-transparent"></div>
                <div className="text-[9px] font-black text-white tracking-[0.4em] uppercase text-center mt-2">SYSTEM_STABLE_v10.0.12</div>
                <div className="text-[7px] font-mono text-white/40 tracking-[0.3em] uppercase italic font-bold text-center">ID: DEGEN_PROTOCOL_CORE</div>
            </div>
        </div>
      </div>

      {/* DESKTOP OPTIMIZED DASHBOARD (HIDDEN ON MOBILE) */}
      <div style={{ width: 1100 * scale, height: 1100 * scale }} className="hidden xl:flex items-center justify-center relative z-10 order-1 xl:order-none mt-12 xl:mt-0 mb-12 xl:mb-0 shrink-0">
        <div 
          className="relative bg-no-repeat bg-cover bg-center shadow-[0_0_100px_rgba(34,211,238,0.15)] overflow-hidden"
          style={{ width: '1100px', height: '1100px', transform: `scale(${scale})`, transformOrigin: 'center center', backgroundImage: "url('/bg-clean.png')" }}
        >
          <div className="absolute top-[6%] left-[6%] right-[6%] flex justify-between items-start z-50">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
                <h2 className="text-xs font-black tracking-[0.4em] text-emerald-400 uppercase">VAULT_LIQUIDITY_LIVE</h2>
              </div>
              <div className="text-4xl font-black tracking-tight text-white flex items-baseline gap-2">
                <span className="text-emerald-400 text-2xl">$</span>
                2,842,109.42
              </div>
              <div className="flex gap-6 mt-2">
                <div className="flex items-center gap-2">
                   <div className="w-1.5 h-1.5 bg-orange-400"></div>
                   <span className="text-[10px] font-black text-white uppercase tracking-widest">BTC: 4.2 <span className="text-white/40 ml-1">($284K)</span></span>
                </div>
                <div className="flex items-center gap-2">
                   <div className="w-1.5 h-1.5 bg-blue-400"></div>
                   <span className="text-[10px] font-black text-white uppercase tracking-widest">ETH: 82.5 <span className="text-white/40 ml-1">($206K)</span></span>
                </div>
                <div className="flex items-center gap-2">
                   <div className="w-1.5 h-1.5 bg-yellow-400"></div>
                   <span className="text-[10px] font-black text-white uppercase tracking-widest">PAXG: 120.0 <span className="text-white/40 ml-1">($240K)</span></span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-end gap-3">
              <div className="px-6 py-2 bg-white/5 border-2 border-white/10 rounded-lg text-xs font-black text-white tracking-[0.2em] uppercase shadow-[0_0_20px_rgba(255,255,255,0.05)]">
                MULTISIG: 0x0C9f...3Bb6
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-magenta-400 rounded-full animate-pulse"></div>
                <div className="text-[10px] font-black text-magenta-400/80 uppercase tracking-[0.3em]">AWAITING_PROFIT_INJECTION...</div>
              </div>
              <div className="text-[10px] font-black text-emerald-400/50 uppercase tracking-[0.4em] italic">VAULT_STATUS: SECURED_DEEP_COLD</div>
            </div>
          </div>

          <div className="absolute top-[18%] left-1/2 -translate-x-1/2 flex items-center gap-4">
            <div className="w-10 h-10 bg-contain bg-no-repeat" style={{ backgroundImage: "url('/favicon.svg')" }}></div>
            <h1 className="text-2xl font-black tracking-[0.2em] text-white opacity-90 drop-shadow-[0_0_15px_rgba(0,255,136,0.5)] uppercase">KEDZÆCARTA</h1>
          </div>

          <div className="absolute top-[17%] right-[6%] z-50 transform-gpu">
            <button 
              onClick={async () => {
                if (typeof window !== 'undefined' && (window as any).ethereum) {
                  try {
                    const accounts = await (window as any).ethereum.request({ method: 'eth_requestAccounts' });
                    if (accounts && accounts.length > 0) {
                      setIsConnected(true);
                      setWalletAddress(accounts[0]);
                    }
                  } catch (e) {
                    console.error("User rejected request");
                  }
                } else {
                  alert('Web3 Wallet not found! Please install MetaMask.');
                }
              }}
              className={`px-6 py-2 border-2 transition-all text-[10px] font-black uppercase tracking-widest rounded-full shadow-[0_0_20px_rgba(34,211,238,0.3)] cursor-pointer ${isConnected ? 'bg-cyan-500/20 border-cyan-500/40 text-cyan-400' : 'bg-magenta-500/20 border-magenta-400 text-magenta-400 hover:bg-magenta-400 hover:text-black'}`}
            >
              {isConnected ? `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}` : 'CONNECT WALLET'}
            </button>
          </div>

          <div className="absolute top-[35%] left-[13%] w-[35%] text-center">
              <h2 className="text-xl font-black text-white tracking-[0.3em] mb-2 uppercase">STAKE FARMER NFT</h2>
              <p className="text-[9px] font-bold text-cyan-400/80 tracking-[0.1em] uppercase px-8">Lock your Farmer NFT to harvest KCFT yields.</p>
          </div>

          <div className="absolute top-[45%] left-[18.5%] w-[24%] h-[6.5%] z-20 flex items-center">
            <input 
              type="number" placeholder="ID #" value={stakeAmount}
              onChange={(e) => setStakeAmount(e.target.value)}
              className="w-full h-full bg-[#0F0B1A]/40 border-b-2 border-cyan-500/30 p-4 pr-16 text-white text-3xl outline-none font-black font-sans text-right placeholder-cyan-900/50"
            />
            <button onClick={() => setShowFarmerModal(true)} className="absolute right-4 text-cyan-400 font-black text-[9px] hover:text-white uppercase tracking-[0.2em] bg-cyan-500/10 px-2 py-1 rounded-full border border-cyan-500/20 transition-all cursor-pointer">SELECT</button>
          </div>

          <div className="absolute top-[35%] right-[13%] w-[35%] text-center">
              <h2 className="text-xl font-black text-white tracking-[0.3em] mb-2 uppercase">YIELD HARVEST</h2>
              <p className="text-[9px] font-bold text-emerald-400/80 tracking-[0.1em] uppercase px-8">Real-time yields aggregated from RWA vault assets.</p>
          </div>

          <div className="absolute top-[44.5%] right-[17.5%] w-[26%] h-[5%] z-20 flex items-center justify-between gap-4">
            <span className="text-[10px] font-black text-cyan-400 tracking-widest opacity-80 min-w-[50px]">[ BTCB ]</span>
            <div className="flex-1 h-full bg-[#0a0a1a]/70 flex items-center justify-end pr-6 text-xl font-black font-sans text-cyan-400 tracking-tighter rounded-lg border border-cyan-900/20">{yields.btcb.toFixed(6)}</div>
          </div>
          <div className="absolute top-[52.5%] right-[17.5%] w-[26%] h-[5%] z-20 flex items-center justify-between gap-4">
            <span className="text-[10px] font-black text-purple-400 tracking-widest opacity-80 min-w-[50px]">[ ETH ]</span>
            <div className="flex-1 h-full bg-[#0a0a1a]/70 flex items-center justify-end pr-6 text-xl font-black font-sans text-purple-400 tracking-tighter rounded-lg border border-purple-900/20">{yields.eth.toFixed(5)}</div>
          </div>
          <div className="absolute top-[60.5%] right-[17.5%] w-[26%] h-[5%] z-20 flex items-center justify-between gap-4">
            <span className="text-[10px] font-black text-green-400 tracking-widest opacity-80 min-w-[50px]">[ USDT ]</span>
            <div className="flex-1 h-full bg-[#0a0a1a]/70 flex items-center justify-end pr-6 text-xl font-black font-sans text-green-400 tracking-tighter rounded-lg border border-green-900/20">{yields.usdt.toFixed(2)}</div>
          </div>
          <div className="absolute top-[68.5%] right-[17.5%] w-[26%] h-[5%] z-20 flex items-center justify-between gap-4">
            <span className="text-[10px] font-black text-yellow-400 tracking-widest opacity-80 min-w-[50px]">[ PAXG ]</span>
            <div className="flex-1 h-full bg-[#0a0a1a]/70 flex items-center justify-end pr-6 text-xl font-black font-sans text-yellow-400 tracking-tighter rounded-lg border border-yellow-900/20">{yields.paxg.toFixed(5)}</div>
          </div>

          <video autoPlay loop muted playsInline className="absolute bottom-[8%] right-[2%] w-[18%] aspect-square z-[60] drop-shadow-[0_0_40px_rgba(34,211,238,0.6)] object-contain pointer-events-none">
            <source src="/shiba_sitting.webm" type="video/webm" />
          </video>

          <div className="absolute bottom-[18%] left-[30%] w-[16%] -translate-x-1/2 h-[6%] z-50">
            <button 
              className={`w-full h-full transition-all duration-500 rounded-lg cursor-pointer border-l-4 flex items-center justify-center font-black tracking-[0.3em] text-[10px] uppercase ${isConnected ? 'bg-cyan-500/5 hover:bg-cyan-500/20 border-cyan-400 text-cyan-400 shadow-[0_0_20px_rgba(34,211,238,0.1)]' : 'bg-red-500/5 hover:bg-red-500/10 border-red-500 text-red-500/80 animate-pulse'}`}
              onClick={() => isConnected && alert(`STAKING FARMER ID: ${stakeAmount || '0'}`)}
            >
              {isConnected ? 'EXECUTE STAKE' : 'SYSTEM LOCKED'}
            </button>
          </div>

          <div className="absolute bottom-[18%] right-[30%] w-[16%] translate-x-1/2 h-[6%] z-50">
            <button 
              className={`w-full h-full transition-all duration-500 rounded-lg border-r-4 flex items-center justify-center font-black tracking-[0.3em] text-[10px] uppercase ${isConnected ? 'bg-emerald-500/5 hover:bg-emerald-500/20 border-emerald-400 text-emerald-400 cursor-pointer shadow-[0_0_30px_rgba(16,185,129,0.2)]' : 'bg-gray-900/40 border-gray-800 text-gray-700 cursor-not-allowed opacity-50'}`}
              onClick={() => isConnected && (alert('HARVESTING ALL RWA YIELDS...'), setYields({ btcb: 0, eth: 0, usdt: 0, paxg: 0 }))}
            >
              {isConnected ? 'HARVEST ALL' : 'OFFLINE'}
            </button>
          </div>

          <a href="https://T.me/Degen_Protocol" target="_blank" rel="noopener noreferrer" className="absolute bottom-[13.5%] left-1/2 -translate-x-1/2 text-center no-underline hover:scale-105 transition-transform duration-300 group cursor-pointer z-50">
              <div className="text-[10px] font-black tracking-[0.4em] uppercase flex items-center gap-2">
                  <span className="text-white/60 group-hover:text-white transition-colors mr-1">CODED BY</span>
                  <span className="text-cyan-400 drop-shadow-[0_0_8px_rgba(34,211,238,0.6)] group-hover:drop-shadow-[0_0_12px_rgba(34,211,238,0.8)]">BLACKSHEEP</span>
                  <span className="text-white/40 mx-2">//</span>
                  <span className="text-[#FF00FF] drop-shadow-[0_0_8px_rgba(255,0,255,0.6)] group-hover:drop-shadow-[0_0_12px_rgba(255,0,255,0.8)]">DEGEN_PROTOCOL</span>
              </div>
          </a>

          <div className="absolute bottom-[5%] left-1/2 -translate-x-1/2 flex items-center gap-6 z-50">
            <div className="flex items-center gap-2">
              <div className={`w-1.5 h-1.5 rounded-full ${isConnected ? 'bg-emerald-400 animate-pulse' : 'bg-red-500'}`}></div>
              <span className="text-[8px] font-black text-gray-500 tracking-[0.2em] uppercase">{isConnected ? 'Network: MAINNET_READY' : 'Network: DISCONNECTED'}</span>
            </div>
            <div className="w-[1px] h-3 bg-gray-800"></div>
            <div className="text-[8px] font-black text-gray-500 tracking-[0.2em] uppercase">Protocol: KEDZACARTA_v5.0_STABLE</div>
            <div className="w-[1px] h-3 bg-gray-800"></div>
            <div className="text-[8px] font-black text-cyan-500/60 tracking-[0.2em] uppercase">Total Sessions: {sessionCount.toLocaleString()}</div>
          </div>
        </div>
      </div>

      {/* FARMER SELECTION MODAL */}
      {showFarmerModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-in fade-in zoom-in duration-300">
          <div className="relative w-full max-w-2xl bg-[#0F0B1A] border border-cyan-500/50 rounded-2xl p-8 shadow-[0_0_50px_rgba(34,211,238,0.15)] flex flex-col gap-6">
            <div className="flex justify-between items-center border-b border-cyan-500/20 pb-4">
               <h2 className="text-2xl font-black text-cyan-400 tracking-[0.3em] uppercase">SELECT FARMER NFT</h2>
               <button onClick={() => setShowFarmerModal(false)} className="text-cyan-400 hover:text-white transition-colors cursor-pointer">
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
               </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto pr-2">
               {mockFarmers.map(farmer => (
                 <div 
                   key={farmer.id}
                   onClick={() => { setStakeAmount(farmer.id); setShowFarmerModal(false); }}
                   className={`flex items-center gap-4 p-4 rounded-xl border cursor-pointer transition-all ${stakeAmount === farmer.id ? 'border-cyan-400 bg-cyan-400/20 shadow-[0_0_20px_rgba(34,211,238,0.2)]' : 'border-cyan-500/20 bg-cyan-900/10 hover:border-cyan-400/60 hover:bg-cyan-900/30'}`}
                 >
                    <div className="w-16 h-16 shrink-0 rounded bg-black border border-cyan-500/30 flex items-center justify-center shadow-[inset_0_0_10px_rgba(34,211,238,0.2)] overflow-hidden">
                       <span className="text-[8px] text-cyan-400/50 font-mono rotate-45">NFT_IMG</span>
                    </div>
                    <div className="flex flex-col">
                       <span className="text-sm font-black text-white tracking-widest">{farmer.name}</span>
                       <span className="text-[10px] font-bold text-cyan-400 uppercase tracking-widest mt-1">ID: {farmer.id}</span>
                       <span className="text-[8px] font-bold text-white/40 uppercase tracking-widest mt-1">{farmer.power}</span>
                    </div>
                 </div>
               ))}
            </div>
            
            <div className="flex justify-end pt-4 border-t border-cyan-500/20">
               <button onClick={() => setShowFarmerModal(false)} className="px-8 py-3 bg-cyan-500/10 hover:bg-cyan-500/20 border border-cyan-500 text-cyan-400 font-black tracking-[0.2em] rounded uppercase transition-colors shadow-[0_0_15px_rgba(34,211,238,0.2)] cursor-pointer">CANCEL</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
